import React, { FC } from 'react'
import styled from 'styled-components'

// Atomic
import { ResponsiveSize } from '@/components/atomic/_enums'
import Text from '@/components/atomic/atoms/Text'
import Card from '@/components/atomic/molecules/Card'
// Cell
import COLOR from '@/components/cell/designTokens/color'
import Button from '@/components/cell/molecules/Button'

const ConfirmCointainer = styled.div`
  width: 310px;
  min-height: 160px;
  margin: 0 auto;

  div[class^='Card'] {
    height: 100%;
    p {
      margin-top: 8px;
      line-height: 20px;
    }
    div.confirmButtonWrapper {
      margin-top: 24px;
      text-align: right;
      button:first-child {
        margin-right: 8px;
      }
    }
  }

  @media screen and (max-width: ${ResponsiveSize.TABLET_MAX_WIDTH}px) {
    width: calc(100vw - 50px);
  }
`

interface Props {
  title: string
  content: string
  okText: string
  cancelText: string
  onConfirm: (isOk: boolean) => void
}
const Confirm: FC<Props> = ({ title, content, okText, cancelText, onConfirm }) => {
  return (
    <ConfirmCointainer>
      <Card padding={24}>
        <Text element="h2" type="title3">
          {title}
        </Text>
        <Text element="p" type="description2" color={COLOR.gray800}>
          {content}
        </Text>
        <div className="confirmButtonWrapper">
          <Button color="tertiary" size="medium" onClick={() => onConfirm(false)}>
            <Text type="title4">{cancelText}</Text>
          </Button>
          <Button color="primary" size="medium" onClick={() => onConfirm(true)}>
            <Text type="title4" color={COLOR.white}>
              {okText}
            </Text>
          </Button>
        </div>
      </Card>
    </ConfirmCointainer>
  )
}

export default Confirm
